import { createRouter, createWebHistory } from 'vue-router'
import Cookies from 'js-cookie'


import HomePage from '@/pages/HomePage.vue'
import Portfolio from '@/pages/PortfolioPage.vue'
import Services from '@/pages/ServicesPage.vue'
import Pairboard from '@/pages/PairboardPage.vue'
import OffMelrose from '@/pages/OffMelrosePage.vue'
import Blingram from '@/pages/BlingramPage.vue'
import Finify from '@/pages/FinifyPage.vue'
import Contact from '@/pages/ContactPage.vue'
import Strategy from '@/pages/StrategyPage.vue'
import Design from '@/pages/DesignPage.vue'
import Development from '@/pages/DevelopmentPage.vue'
import Marketing from '@/pages/MarketingPage.vue'
import Shopify from '@/pages/ShopifyPage.vue'
import Eoncycle from '@/pages/EoncyclePage.vue'
import WebDev from '@/pages/WebDev.vue'
import WebDevShort from '@/pages/WebDevShort.vue'
import WebDevAggressive from '@/pages/WebDevAggressive.vue'
import LeadGen from '@/pages/LeadGen.vue'

const webDevVariants = [
  { name: 'WebDev', component: WebDev },
  { name: 'WebDevShort', component: WebDevShort },
  { name: 'WebDevAggressive', component: WebDevAggressive },
]
import WebMaintenance from '@/pages/WebMaintenancePage.vue'
import { nextTick } from 'vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomePage
  },
  {
    path: '/portfolio',
    name: 'Portfolio',
    component: Portfolio
  },
  {
    path: '/strategy',
    name: 'Strategy',
    component: Strategy
  },
  {
    path: '/pairboard',
    name: 'Pairboard',
    component: Pairboard
  },
  {
    path: '/blingram',
    name: 'Blingram',
    component: Blingram
  },
  {
    path: '/finify',
    name: 'Finify',
    component: Finify
  },
  {
    path: '/off-melrose',
    name: 'OffMelrose',
    component: OffMelrose
  },
  {
    path: '/contact',
    name: 'Contact',
    component: Contact
  },
  {
    path: '/services',
    name: 'Services',
    component: Services
  },
  {
    path: '/marketing',
    name: 'Marketing',
    component: Marketing
  },
  {
    path: '/design',
    name: 'Design',
    component: Design
  },
  {
    path: '/development',
    name: 'Development',
    component: Development
  },
  {
    path: '/shopify',
    name: 'Shopify',
    component: Shopify
  },
  {
    path: '/eoncycle',
    name: 'Eoncycle',
    component: Eoncycle
  },
  {
    path: '/lead-gen',
    name: 'lead-gen',
    component: LeadGen
  },
  {
    path: '/web-development',
    name: 'WebDev',
    component: () => {
      let variantName = Cookies.get('webDevVariant')
      let variant = webDevVariants.find(v => v.name === variantName)
      if (!variant) {
        variant = webDevVariants[Math.floor(Math.random() * webDevVariants.length)]
        Cookies.set('webDevVariant', variant.name, { expires: 7 })
      }
      return Promise.resolve(variant.component)
    } 
  },
  {
    path: '/web-maintenance',
    name: 'WebMaintenance',
    component: WebMaintenance
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    return new Promise(resolve => {
      // give Vue a moment to render
      setTimeout(async () => {
        await nextTick()
        if (savedPosition) {
          // back/forward buttons
          resolve(savedPosition)
        } else if (to.hash) {
          // anchor links
          resolve({ el: to.hash, behavior: 'smooth' })
        } else {
          // all other navigations → top
          window.scrollTo({ top: 0, behavior: 'smooth' })
          resolve({ top: 0 })
        }
      }, 250) // tweak delay as needed
    })
  }
})

router.afterEach((to) => {
  if (window.hj) {
    window.hj('stateChange', to.fullPath);
  }
});

  
export default router
